import cxReport from './routes/cx-report/cxReport.vue';
import cxDetailComplaint from './routes/cx-report/component/detailComplaint.vue';
const cxDetailClaim = () => import('./routes/cx-report/component/detailClaim.vue');
import cxDetailFeedback from './routes/cx-report/component/detailFeedback.vue';
import cxDetailInformation from './routes/cx-report/component/detailInformation.vue';

import cxAutoClaim from './routes/cx-auto-claim/cxAutoClaim.vue';
const cxDetailAutoClaim = () => import('./routes/cx-auto-claim/component/detailAutoClaim.vue');
import cxDetailComplaintAutoClaim from './routes/cx-auto-claim/component/detailComplaintAutoClaim.vue';
import cxDetailFeedbackAutoClaim from './routes/cx-auto-claim/component/detailFeedbackAutoClaim.vue';
import cxDetailInformationAutoClaim from './routes/cx-auto-claim/component/detailInformationAutoClaim.vue';

import cxInstantClaim from './routes/cx-instant-claim/cxInstantClaim.vue';
const cxDetailInstantClaim = () => import('./routes/cx-instant-claim/component/detailInstantClaim.vue');
import cxDetailComplaintInstantClaim from './routes/cx-instant-claim/component/detailComplaintInstantClaim.vue';
import cxDetailFeedbackInstantClaim from './routes/cx-instant-claim/component/detailFeedbackInstantClaim.vue';
import cxDetailInformationInstantClaim from './routes/cx-instant-claim/component/detailInformationInstantClaim.vue';

import cxFoodClaim from './routes/cx-food-claim/cxFoodClaim.vue';
const cxDetailFoodClaim = () => import('./routes/cx-food-claim/component/detailFoodClaim.vue');
import cxDetailComplaintFoodClaim from './routes/cx-food-claim/component/detailComplaintFoodClaim.vue';
import cxDetailFeedbackFoodClaim from './routes/cx-food-claim/component/detailFeedbackFoodClaim.vue';
import cxDetailInformationFoodClaim from './routes/cx-food-claim/component/detailInformationFoodClaim.vue';

import cxCorporateClaim from './routes/cx-corporate-claim/cxCorporateClaim.vue';
import cxDetailComplaintCorporate from './routes/cx-corporate-claim/component/detailComplaintCorporate.vue';
const cxDetailClaimCorporate = () => import('./routes/cx-corporate-claim/component/detailClaimCorporate.vue');
import cxDetailFeedbackCorporate from './routes/cx-corporate-claim/component/detailFeedbackCorporate.vue';
import cxDetailInformationCorporate from './routes/cx-corporate-claim/component/detailInformationCorporate.vue';

const claimSettingPINSetting = () => import('./routes/claim-setting/pin-setting/PINSetting.vue');
const claimSettingPaymentLimitation = () => import('./routes/claim-setting/payment-limitation/PaymentLimitation.vue')
const claimExcess = () => import('./routes/claim-excess/ClaimExcess.vue');
const claimSettingDisbursementTime = () => import('./routes/claim-setting/payment-disbursement-time/PaymentDisbursementTime.vue');
const cxRoutes = [
  {
    path: '/cx_report',
    name: 'cxReport',
    component: cxReport,
  },
  {
    path: '/cx-detail-complaint/:id',
    name: 'cxDetailComplaint',
    component: cxDetailComplaint,
  },
  {
    path: '/cx-detail-claim/:id',
    name: 'cxDetailClaim',
    component: cxDetailClaim,
  },
  {
    path: '/cx-detail-feedback/:id',
    name: 'cxDetailFeedback',
    component: cxDetailFeedback,
  },
  {
    path: '/cx-detail-information/:id',
    name: 'cxDetailInformation',
    component: cxDetailInformation,
    props: true,
  },
  // 
  {
    path: '/cx_auto_claim',
    name: 'cxAutoClaim',
    component: cxAutoClaim,
  },
  {
    path: '/cx-detail-auto-claim/:id',
    name: 'cxDetailAutoClaim',
    component: cxDetailAutoClaim,
  },
  {
    path: '/cx-detail-complaint-auto-claim/:id',
    name: 'cxDetailComplaintAutoClaim',
    component: cxDetailComplaintAutoClaim,
  },
  {
    path: '/cx-detail-feedback-auto-claim/:id',
    name: 'cxDetailFeedbackAutoClaim',
    component: cxDetailFeedbackAutoClaim,
  },
  {
    path: '/cx-detail-information-auto-claim/:id',
    name: 'cxDetailInformationAutoClaim',
    component: cxDetailInformationAutoClaim,
    props: true,
  },
  // 
  {
    path: '/cx_instant_claim',
    name: 'cxInstantClaim',
    component: cxInstantClaim,
  },
  {
    path: '/cx-detail-instant-claim/:id',
    name: 'cxDetailInstantClaim',
    component: cxDetailInstantClaim,
  },
  {
    path: '/cx-detail-complaint-instant-claim/:id',
    name: 'cxDetailComplaintInstantClaim',
    component: cxDetailComplaintInstantClaim,
  },
  {
    path: '/cx-detail-feedback-instant-claim/:id',
    name: 'cxDetailFeedbackInstantClaim',
    component: cxDetailFeedbackInstantClaim,
  },
  {
    path: '/cx-detail-information-instant-claim/:id',
    name: 'cxDetailInformationInstantClaim',
    component: cxDetailInformationInstantClaim,
    props: true,
  },
  // 
  {
    path: '/cx_food_claim',
    name: 'cxFoodClaim',
    component: cxFoodClaim,
  },
  {
    path: '/cx-detail-food-claim/:id',
    name: 'cxDetailFoodClaim',
    component: cxDetailFoodClaim,
  },
  {
    path: '/cx-detail-complaint-food-claim/:id',
    name: 'cxDetailComplaintFoodClaim',
    component: cxDetailComplaintFoodClaim,
  },
  {
    path: '/cx-detail-feedback-food-claim/:id',
    name: 'cxDetailFeedbackFoodClaim',
    component: cxDetailFeedbackFoodClaim,
  },
  {
    path: '/cx-detail-information-food-claim/:id',
    name: 'cxDetailInformationFoodClaim',
    component: cxDetailInformationFoodClaim,
    props: true,
  },
  //
  {
    path: '/cx_corporate_claim',
    name: 'cxCorporateClaim',
    component: cxCorporateClaim,
  },
  {
    path: '/cx-detail-complaint-corporate/:id',
    name: 'cxDetailComplaintCorporate',
    component: cxDetailComplaintCorporate,
  },
  {
    path: '/cx-detail-claim-corporate/:id',
    name: 'cxDetailClaimCorporate',
    component: cxDetailClaimCorporate,
  },
  {
    path: '/cx-detail-feedback-corporate/:id',
    name: 'cxDetailFeedbackCorporate',
    component: cxDetailFeedbackCorporate,
  },
  {
    path: '/cx-detail-information-corporate/:id',
    name: 'cxDetailInformationCorporate',
    component: cxDetailInformationCorporate,
    props: true,
  },
  {
    path: '/claim-setting/pin-setting',
    name: 'claimSettingPINSetting',
    component: claimSettingPINSetting,
  },
  {
    path: '/claim-setting/payment-limitation',
    name: 'claimSettingPaymentLimitation',
    component: claimSettingPaymentLimitation,
  },
  {
    path: '/claim-setting/disbursement-time',
    name: 'claimSettingDisbursementTime',
    component: claimSettingDisbursementTime,
    meta: { roles: ['superadmin', 'claim_manager'] },
  },
  {
    path: '/claim-excess',
    name: 'claimExcess',
    component: claimExcess,
  },

];

export default cxRoutes;
